<template>
  <b-container class="highlight-container">

    <router-link to="/"><i class="fas fa-times btn--close"></i></router-link>

    <b-row>
      <b-col md="12" class="text-center px-0">
        <h1 v-scroll-reveal>3,750 Acres <br>of Proposed Hiking <br>& Cycling Trails</h1>
        <div class="image-wrapper" v-scroll-reveal="{delay: 150}">
          <b-img src="/img/trails-highlight-banner.png" fluid center alt="New Trails"/>
        </div>
      </b-col>
    </b-row>

    <b-row class="background--white">
      <b-col md="10" offset-md="1" class="text-center">
        <h3 class="text--red text--extrabold mb-25"><a data-fancybox="video" href="https://player.vimeo.com/video/359571618?title=0&byline=0&portrait=0&transparent=0">WATCH VIDEO</a></h3>
        <p v-scroll-reveal>
          Enjoying a walk in nature is one of the best things that you can do for your health, especially <br class="d-none d-xl-block">when
          you do
          it with the people you care about. In fact, a recent study from the University of Michigan <br class="d-none d-xl-block">found
          that taking
          group nature walks is associated with decreased depression, lower stress and <br class="d-none d-xl-block">improved
          well-being. Walking or
          cycling in nature are also great ways to get your recommended <br class="d-none d-xl-block">30 minutes of
          moderate exercise every day. When
          you live at New Seaton, it will be easier than ever <br class="d-none d-xl-block">to start enjoying all of
          these incredible health benefits.
        </p>
        <highlight-footer slot="register" />
      </b-col>
    </b-row>
    
  </b-container>
</template>

<script>
  import highlightFooter from '@/components/HighlightFooter';
  export default {
    components: {
      highlightFooter
    },
    mounted() {
      this.$root.layout.methods.triggerViewPortAnimation()
    },
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        done()
      },
      leave(el, done) {
        done()
      },
    },
  }

</script>

<style scoped>

</style>
